// Constants for repeated strings
const STATIC_PATH = '/static/';
const PLACEHOLDER_IMAGE =
	'/static/assets/images/ui/portrait-placeholder-v1.png';
const DEALER_DOMAIN_REGEX =
	/(.*\/\/.*)?(pictures|images|static)(\.)([^.]+\.)?dealer\.com(.*)/;

/**
 * Checks if a URL matches Dealer.com image hosting domains.
 *
 * @param {string} url - The URL to check.
 * @returns {boolean} True if the URL matches, otherwise false.
 */
export const isDealerImage = (url) => {
	if (!url) return false;
	return DEALER_DOMAIN_REGEX.test(url) || url.startsWith(STATIC_PATH);
};

/**
 * Determines the image dimension based on orientation and context.
 *
 * @param {boolean} isVertical - Whether the image is vertical.
 * @param {boolean} isWithinModal - Whether the image is displayed in a modal.
 * @returns {string} The width of the image ("280" or "150").
 */
const setImageDimension = (isVertical, isWithinModal) => {
	return isVertical || (!isVertical && isWithinModal) ? '280' : '150';
};

/**
 * Generates the appropriate image source URL.
 *
 * @param {string} enableAutoFaceCrop - Whether to enable auto face cropping.
 * @param {string} url - The image URL.
 * @param {boolean} isVertical - Whether the image is vertical.
 * @param {boolean} isWithinModal - Whether the image is displayed in a modal.
 * @param {string} defaultImageOverride - Custom default image URL to use instead of placeholder.
 * @returns {string} The generated image source URL.
 */
export const getImgSrc = (
	enableAutoFaceCrop,
	url,
	isVertical,
	isWithinModal,
	defaultImageOverride = ''
) => {
	if (!url) {
		// Use custom default image if provided, otherwise use standard placeholder
		return defaultImageOverride || PLACEHOLDER_IMAGE;
	}

	const dimension = setImageDimension(isVertical, isWithinModal);
	const baseUrl = url.split('?')[0];

	if (isDealerImage(url)) {
		if (enableAutoFaceCrop === 'true') {
			return `${baseUrl}?impolicy=imquery&im=FaceCrop,algorithm=dnn,width=${dimension}`;
		}
		return `${baseUrl}?impolicy=downsize&w=${dimension}&h=${dimension}`;
	}

	return url;
};
